import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";

import {
  Button,
  PageHeader,
  Popconfirm,
  Space,
  Table,
  Switch,
  Input,
} from "antd";
import type { ColumnsType } from "antd/lib/table";
import WhiteListStore, {
  WhiteInfo,
} from "../../../stores/Admin/WhiteListStore";
import UserStore from "../../../stores/Admin/UserStore";
import WhitePhoneAddDialog from "./dialogs/WhitePhoneAddDialog";
const { Search } = Input;
const WhiteListPage: React.FC = (props) => {
  const { whiteList, listState } = WhiteListStore;

  const [visibles, setVisibles] = useState<{ [key: string]: any }>({
    whiteAdd: false,
  });
  const updateVisibles = (key: string, value: any) => {
    visibles[key] = value;
    setVisibles({ ...visibles });
  };
  const onChange = (checked: boolean) => {
    checked ? WhiteListStore.openList() : WhiteListStore.closeList();
  };
  const onSearch = (value: string) => WhiteListStore.getWhitePageList(value);
  useEffect(() => {
    WhiteListStore.getWhitePageList();
    WhiteListStore.getstate();
  }, []);

  const columns: ColumnsType<WhiteInfo> = [
    {
      title: "序号",
      dataIndex: "num",
      key: "num",
      render: (text, record, index) => <span>{Number(index) + 1}</span>,
    },
    {
      title: "手机号码",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "用户名称",
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{`${text ? text : "一"}`}</span>,
    },
    {
      title: "初始分组",
      dataIndex: "roleName",
      key: "roleName",
      render: (text) => <span>{`${text ? text : "一"}`}</span>,
    },
    {
      title: "添加时间",
      dataIndex: "createdTime",
      key: "createdTime",
      render: (text) => (
        <span>{`${text ? new Date(text).toLocaleString() : "一"}`}</span>
      ),
    },

    {
      title: "操作",
      key: "action",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Popconfirm
              title="确定删除该分组吗?"
              onConfirm={() => WhiteListStore.removeWhitePhone(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <a href="#">删除</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  return (
    <>
      <PageHeader title="白名单管理" />
      <div className={styles.content}>
        <div style={{ marginBottom: 16 }} className={styles.header}>
          <div style={{ display: "flex" }}>
            <Button
              shape="round"
              type="primary"
              onClick={() => {
                updateVisibles("whiteAdd", true);
                UserStore.getRoleList();
              }}
              style={{ marginTop: "3px", marginRight: "5px" }}
            >
              添加手机号
            </Button>
            <Search
              placeholder="输入手机号"
              allowClear
              enterButton="搜索"
              size="large"
              onSearch={onSearch}
            />
          </div>

          <div className={styles.switch}>
            白名单总开关
            <Switch checked={listState} onChange={onChange} />
          </div>
        </div>
        <div className={styles.table_content}>
          <Table columns={columns} dataSource={whiteList} pagination={false} />
        </div>
      </div>
      <WhitePhoneAddDialog
        visible={visibles.whiteAdd}
        close={() => updateVisibles("whiteAdd", false)}
      />
    </>
  );
};

export default observer(WhiteListPage);
